module.exports = __webpack_public_path__ + "img/main_info.d4de5470.jpg";